export const actionTypes = {
  SELECT_CATALOG_OFFICE: "SELECT_CATALOG_OFFICE",
  MODIFY_CATALOG_SELECTED_USERS: "MODIFY_CATALOG_SELECTED_USERS",
  ADMIN_OFFICE_CATALOG_REQUEST: "ADMIN_OFFICE_CATALOG_REQUEST",
  ADMIN_OFFICE_CATALOG_REQUEST_SUCCESS: "ADMIN_OFFICE_CATALOG_REQUEST_SUCCESS",
  ADMIN_OFFICE_CATALOG_REQUEST_FAILURE: "ADMIN_OFFICE_CATALOG_REQUEST_FAILURE",
  ADMIN_GLOBAL_CATALOG_REQUEST: "ADMIN_GLOBAL_CATALOG_REQUEST",
  ADMIN_GLOBAL_CATALOG_REQUEST_SUCCESS: "ADMIN_GLOBAL_CATALOG_REQUEST_SUCCESS",
  ADMIN_GLOBAL_CATALOG_REQUEST_FAILURE: "ADMIN_GLOBAL_CATALOG_REQUEST_FAILURE",
  ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST:
    "ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST",
  ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_SUCCESS:
    "ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_SUCCESS",
  ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_FAILURE:
    "ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_FAILURE",
  ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST:
    "ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST",
  ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS:
    "ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS",
  ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE:
    "ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE",
  ADMIN_CHAIN_ENTITLEMENT_REQUEST: "ADMIN_CHAIN_ENTITLEMENT_REQUEST",
  ADMIN_CHAIN_ENTITLEMENT_REQUEST_SUCCESS:
    "ADMIN_CHAIN_ENTITLEMENT_REQUEST_SUCCESS",
  ADMIN_CHAIN_ENTITLEMENT_REQUEST_FAILURE:
    "ADMIN_CHAIN_ENTITLEMENT_REQUEST_FAILURE",
  MODIFY_CATALOG_DELETED_ENTITLEMENTS: "MODIFY_CATALOG_DELETED_ENTITLEMENTS",
  MODIFY_CATALOG_TOTAL_ENTITLEMENTS: "MODIFY_CATALOG_TOTAL_ENTITLEMENTS",
  MODIFY_CATALOG_PREV_ENTITLEMENTS: "MODIFY_CATALOG_PREV_ENTITLEMENTS",
  MODIFY_CATALOG_ADDED_ENTITLEMENTS: "MODIFY_CATALOG_ADDED_ENTITLEMENTS",
  ADMIN_CREATE_CATALOG_REQUEST: "ADMIN_CREATE_CATALOG_REQUEST",
  ADMIN_CREATE_CATALOG_REQUEST_SUCCESS: "ADMIN_CREATE_CATALOG_REQUEST_SUCCESS",
  ADMIN_CREATE_CATALOG_REQUEST_FAILURE: "ADMIN_CREATE_CATALOG_REQUEST_FAILURE",
  SAVE_ACTION: "SAVE_ACTION",
  SAVE_ACTION_SUCCESS: "SAVE_ACTION_SUCCESS",
  SAVE_ACTION_FAILURE: "SAVE_ACTION_FAILURE",
  RESET_STATE_CATALOG: "RESET_STATE_CATALOG",
  RESET_CHAIN_ENTITLEMENTS: "RESET_CHAIN_ENTITLEMENTS",
  GET_PAGINATION_TABLE_STEP_ONE: "GET_PAGINATION_TABLE_STEP_ONE",
  GET_PAGINATION_TABLE_STEP_ONE_SUCCESS:
    "GET_PAGINATION_TABLE_STEP_ONE_SUCCESS",
  GET_PAGINATION_TABLE_STEP_ONE_FAILURE:
    "GET_PAGINATION_TABLE_STEP_ONE_FAILURE",
  GET_PAGINATION_TABLE_STEP_TWO: "GET_PAGINATION_TABLE_STEP_TWO",
  GET_PAGINATION_TABLE_STEP_TWO_SUCCESS:
    "GET_PAGINATION_TABLE_STEP_TWO_SUCCESS",
  GET_PAGINATION_TABLE_STEP_TWO_FAILURE:
    "GET_PAGINATION_TABLE_STEP_TWO_FAILURE",
  HIDE_OU: "HIDE_OU",
  HIDE_OU_SUCCESS: "HIDE_OU_SUCCESS",
  HIDE_OU_FAILURE: "HIDE_OU_FAILURE",
  SHOW_OU: "SHOW_OU",
  SHOW_OU_SUCCESS: "SHOW_OU_SUCCESS",
  SHOW_OU_FAILURE: "SHOW_OU_FAILURE",
  SET_SELECTED_CATALOG: "SET_SELECTED_CATALOG",
  RESET_ADDED_REMOVED_ENTITLEMENTS: "RESET_ADDED_REMOVED_ENTITLEMENTS",
  CATALOG_SET_START_END_DATE: "CATALOG_SET_START_END_DATE",
  CATALOG_REMOVE_DATE: "CATALOG_REMOVE_DATE",

  GET_SEGREGATIONS_REQUEST: "GET_SEGREGATIONS_REQUEST",
  GET_SEGREGATIONS_REQUEST_SUCCESS: "GET_SEGREGATIONS_REQUEST_SUCCESS",
  GET_SEGREGATIONS_REQUEST_FAILURE: "GET_SEGREGATIONS_REQUEST_FAILURE",
  ADD_SEGREGATION_REQUEST: "ADD_SEGREGATION_REQUEST",
  ADD_SEGREGATION_REQUEST_SUCCESS: "ADD_SEGREGATION_REQUEST_SUCCESS",
  ADD_SEGREGATION_REQUEST_FAILURE: "ADD_SEGREGATION_REQUEST_FAILURE",
  UPDATE_SEGREGATIONS_REQUEST: "UPDATE_SEGREGATIONS_REQUEST",
  UPDATE_SEGREGATIONS_REQUEST_SUCCESS: "UPDATE_SEGREGATIONS_REQUEST_SUCCESS",
  UPDATE_SEGREGATIONS_REQUEST_FAILURE: "UPDATE_SEGREGATIONS_REQUEST_FAILURE",
  DELETE_SEGREGATIONS_REQUEST: "DELETE_SEGREGATIONS_REQUEST",
  DELETE_SEGREGATIONS_REQUEST_SUCCESS: "DELETE_SEGREGATIONS_REQUEST_SUCCESS",
  DELETE_SEGREGATIONS_REQUEST_FAILURE: "DELETE_SEGREGATIONS_REQUEST_FAILURE",

  SELECT_SEGREGATION: "SELECT_SEGREGATION",
};

export const resetAddedRemovedEntitlements = () => ({
  type: actionTypes.RESET_ADDED_REMOVED_ENTITLEMENTS,
});

export const setSelectedCatalog = (payload: any) => ({
  type: actionTypes.SET_SELECTED_CATALOG,
  payload,
});

export const getPaginationTableStepOne = (payload: any) => ({
  type: actionTypes.GET_PAGINATION_TABLE_STEP_ONE,
  payload,
});

export const getPaginationTableStepOneSuccess = (payload: any) => ({
  type: actionTypes.GET_PAGINATION_TABLE_STEP_ONE_SUCCESS,
  payload,
});

export const getPaginationTableStepOneFailure = (err: Error) => ({
  type: actionTypes.GET_PAGINATION_TABLE_STEP_ONE_FAILURE,
  err,
});

export const getPaginationTableStepTwo = (payload: any) => ({
  type: actionTypes.GET_PAGINATION_TABLE_STEP_TWO,
  payload,
});

export const getPaginationTableStepTwoSuccess = (payload: any) => ({
  type: actionTypes.GET_PAGINATION_TABLE_STEP_TWO_SUCCESS,
  payload,
});

export const getPaginationTableStepTwoFailure = (err: Error) => ({
  type: actionTypes.GET_PAGINATION_TABLE_STEP_TWO_FAILURE,
  err,
});

export const hideOu = (payload: any) => ({
  type: actionTypes.HIDE_OU,
  payload,
});

export const hideOuSuccess = (payload: any) => ({
  type: actionTypes.HIDE_OU_SUCCESS,
  payload,
});

export const hideOuFailure = (err: any) => ({
  type: actionTypes.HIDE_OU_FAILURE,
  err,
});

export const showOu = (payload: any) => ({
  type: actionTypes.SHOW_OU,
  payload,
});

export const showOuSuccess = (payload: any) => ({
  type: actionTypes.SHOW_OU_SUCCESS,
  payload,
});

export const showOuFailure = (err: any) => ({
  type: actionTypes.SHOW_OU_FAILURE,
  err,
});

export const officeRequest = () => ({
  type: actionTypes.ADMIN_OFFICE_CATALOG_REQUEST,
});

export const officeRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_OFFICE_CATALOG_REQUEST_SUCCESS,
  payload,
});

export const officeRequestFailure = (err: any) => ({
  type: actionTypes.ADMIN_OFFICE_CATALOG_REQUEST_FAILURE,
  err,
});

export const selectOffice = (id: string) => ({
  type: actionTypes.SELECT_CATALOG_OFFICE,
  id,
});

export const modifySelectedUsers = (selectedUsers: []) => ({
  type: actionTypes.MODIFY_CATALOG_SELECTED_USERS,
  selectedUsers,
});

export const getAdminPaginatedGlobalCatalogAction = (payload: any) => ({
  type: actionTypes.ADMIN_GLOBAL_CATALOG_REQUEST,
  payload,
});
export const getAdminPaginatedGlobalCatalogActionSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_GLOBAL_CATALOG_REQUEST_SUCCESS,
  payload,
});
export const getAdminPaginatedGlobalCatalogActionFailure = (payload: any) => ({
  type: actionTypes.ADMIN_GLOBAL_CATALOG_REQUEST_FAILURE,
  payload,
});

export const entitlementRequest = (obj: any) => ({
  type: actionTypes.ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST,
  obj,
});

export const entitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_SUCCESS,
  payload,
});

export const entitlementRequestFailure = (err: any) => ({
  type: actionTypes.ENTITLEMENT_CATALOG_ADMIN_CONSOLE_REQUEST_FAILURE,
  err,
});

export const officeEntitlementRequest = (id: string | number) => ({
  type: actionTypes.ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST,
  id,
});

export const officeEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_SUCCESS,
  payload,
});

export const officeEntitlementRequestFailure = (err: any) => ({
  type: actionTypes.ADMIN_OFFICE_ENTITLEMENT_CATALOG_REQUEST_FAILURE,
  err,
});

export const chainEntitlementRequest = (payload: any[]) => ({
  type: actionTypes.ADMIN_CHAIN_ENTITLEMENT_REQUEST,
  payload,
});

export const chainEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_CHAIN_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const chainEntitlementRequestFailure = (err: any) => ({
  type: actionTypes.ADMIN_CHAIN_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const modifyDeletedEntitlements = (deletedEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_DELETED_ENTITLEMENTS,
  deletedEntitlements,
});

export const modifyTotalEntitlements = (totalEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_TOTAL_ENTITLEMENTS,
  totalEntitlements,
});

export const modifyPrevEntitlements = (prevEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_PREV_ENTITLEMENTS,
  prevEntitlements,
});

export const modifyAddedEntitlements = (addedEntitlements: []) => ({
  type: actionTypes.MODIFY_CATALOG_ADDED_ENTITLEMENTS,
  addedEntitlements,
});

export const resetStatesCatalog = () => ({
  type: actionTypes.RESET_STATE_CATALOG,
});

export const createRequest = (payload: {}) => ({
  type: actionTypes.ADMIN_CREATE_CATALOG_REQUEST,
  payload,
});

export const createRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_CREATE_CATALOG_REQUEST_SUCCESS,
  payload,
});

export const createRequestFailure = (err: any) => ({
  type: actionTypes.ADMIN_CREATE_CATALOG_REQUEST_FAILURE,
  err,
});

export const saveAction = (payload: {}) => ({
  type: actionTypes.SAVE_ACTION,
  payload,
});

export const saveActionSuccess = (payload: any) => ({
  type: actionTypes.SAVE_ACTION_SUCCESS,
  payload,
});

export const saveActionFailure = (err: any) => ({
  type: actionTypes.SAVE_ACTION_FAILURE,
  err,
});

export const resetChainEntitlements = () => ({
  type: actionTypes.RESET_CHAIN_ENTITLEMENTS,
});

export const setStartEndDate = (start: number, end: number, id: string) => ({
  type: actionTypes.CATALOG_SET_START_END_DATE,
  payload: {
    start,
    end,
    id,
  },
});

export const removeStartEndDate = (id: string) => ({
  type: actionTypes.CATALOG_REMOVE_DATE,
  payload: id,
});

export const getSegregationsRequestAction = () => ({
  type: actionTypes.GET_SEGREGATIONS_REQUEST,
});

export const getSegregationsRequestActionSuccess = (payload: any) => ({
  type: actionTypes.GET_SEGREGATIONS_REQUEST_SUCCESS,
  payload,
});

export const getSegregationsRequestActionFailure = (id: string) => ({
  type: actionTypes.GET_SEGREGATIONS_REQUEST_FAILURE,
  payload: id,
});

export const addSegregationRequestAction = (payload: any) => ({
  type: actionTypes.ADD_SEGREGATION_REQUEST,
  payload,
});

export const addSegregationRequestActionSuccess = (payload: any) => ({
  type: actionTypes.ADD_SEGREGATION_REQUEST_SUCCESS,
  payload,
});

export const addSegregationRequestActionFailure = (id: string) => ({
  type: actionTypes.ADD_SEGREGATION_REQUEST_FAILURE,
  payload: id,
});

export const updateSegregationsRequestAction = (payload: any) => ({
  type: actionTypes.UPDATE_SEGREGATIONS_REQUEST,
  payload,
});

export const updateSegregationsRequestActionSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_SEGREGATIONS_REQUEST_SUCCESS,
  payload,
});

export const updateSegregationsRequestActionFailure = (id: string) => ({
  type: actionTypes.UPDATE_SEGREGATIONS_REQUEST_FAILURE,
  payload: id,
});

export const deleteSegregationsRequestAction = (payload: any) => ({
  type: actionTypes.DELETE_SEGREGATIONS_REQUEST,
  payload,
});

export const deleteSegregationsRequestActionSuccess = (payload: any) => ({
  type: actionTypes.DELETE_SEGREGATIONS_REQUEST_SUCCESS,
  payload,
});

export const deleteSegregationsRequestActionFailure = (id: string) => ({
  type: actionTypes.DELETE_SEGREGATIONS_REQUEST_FAILURE,
  payload: id,
});

export const selectSegregationAction = (payload: any) => ({
  type: actionTypes.SELECT_SEGREGATION,
  payload,
});
